import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

let localStorageLanguage = localStorage.getItem("locale") || "en";
// console.log(localStorage.getItem("locale"),"json")
// let localStorageLanguage = "en";

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: localStorageLanguage,
  resources: {
    en: {
      translations: require('./locales/en/translations.json')
    },
    hi: {
      translations: require('./locales/hi/translations.json')
    },
    te: {
        translations: require('./locales/te/translations.json')
      }
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['en', 'hi', 'te'];

export default i18n;